<template>
  <div v-if="showListView" class="rfp-storelocator-store-list-start">
    <p v-if="!markerData.length" class="rfp-storelocator-no-results">{{ noStore }}</p>
    <ul
      v-else
      class="salonstore-list"
      :style="{ display: activeStatus }"
      :class="{ 'salonstore-list-with-promotion': promotionEnabled }"
    >
      <li v-for="item in markerData" :key="item.id" class="stlc-list-item">
        <div v-if="showItemNumber" class="rfp-storelocator-index-design storelocater-col-md-2">
          {{ iriEnabled ? item.Number : item.id }}
        </div>
        <div
          class="storelocater-col-md-10 stlc__store_list_common"
          :class="{ 'storelocater-col-md-12': showMobileMedia }"
        >
          <div
            class="storelocater-col-md-12 stlc_padding_0px storelocator-clickable-card"
            @click="handleStoreClick(item)"
          >
            <p
              role="button"
              tabindex="0"
              class="rfp-storelocator-list-header rfp-storelocator-list-001"
              aria-haspopup="dialog"
              @keydown.enter="handleStoreClick(item)"
              @keydown.space.prevent="handleStoreClick(item)"
            >
              {{ item.Name }}
            </p>
            <div class="stlc__height_default stlc_padding_0px">
              <p v-if="allIcons.Location != ''" class="storelocater-col-md-2 stlc_padding_0px">
                <img
                  :alt="allIcons.LocationAlt"
                  :src="allIcons.Location"
                  class="stlc-store-list-icons"
                />
              </p>
              <div
                class="storelocater-col-md-10 stlc_padding_0px"
                :class="{
                  'storelocater-col-md-12': allIcons.Location === '' || allIcons.Location === null,
                }"
              >
                <p v-if="item.Address1 != ''">{{ item.Address1 }}</p>
                <p v-if="item.Address2 != ''">{{ item.Address2 }}</p>
                <p v-if="item.Address3 != ''">{{ item.Address3 }}</p>
                <p>
                  <span v-if="item.City != null">{{ item.City }}</span
                  ><span v-if="item.State != null">, {{ item.State }}</span>
                </p>
                <p>
                  <span v-if="item.Country != null">{{ item.Country }}</span>
                </p>
                <p v-if="item.PostalCode">
                  <span>{{ item.PostalCode }}</span>
                </p>
              </div>
            </div>
          </div>

          <div
            v-if="item.WorkingHours != null"
            class="stlc_padding_bottom_15px stlc__height_default storelocater-col-md-12"
          >
            <div v-if="allIcons.Schedule != ''" class="storelocater-col-md-2 stlc_padding_0px">
              <img
                :alt="allIcons.ScheduleAlt"
                :src="allIcons.Schedule"
                class="stlc-store-list-icons"
              />
            </div>
            <div
              class="storelocater-col-md-10 stlc_padding_0px"
              :class="{
                'storelocater-col-md-12': allIcons.Schedule === '' || allIcons.Schedule === null,
              }"
            >
              <p class="stlc_margin_left_right_5px">
                {{ item.WorkingHours }}
              </p>
            </div>
          </div>

          <div
            v-if="item.Website != null"
            class="stlc_padding_bottom_15px stlc__height_default storelocater-col-md-12"
          >
            <div
              v-if="allIcons.Website != '' || allIcons.Website != null"
              class="storelocater-col-md-2 stlc_padding_0px"
            >
              <img
                :alt="allIcons.WebsiteAlt"
                :src="allIcons.Website"
                class="stlc-store-list-icons"
              />
            </div>
            <div
              class="storelocater-col-md-10 stlc_padding_0px"
              :class="{
                'storelocater-col-md-12': allIcons.Website === '' || allIcons.Website === null,
              }"
            >
              <p class="stlc_margin_left_right_5px">
                <a
                  class="stlc_color_blue"
                  target="_blank"
                  :href="item.Website"
                  @click="dataLayerTagging(bookStoreTags, item.Name)"
                >
                  {{ getWebsiteBaseData(item.Website) }}
                </a>
              </p>
            </div>
          </div>

          <div
            v-if="item.PhoneNumber != null"
            class="stlc_padding_bottom_15px stlc__height_default storelocater-col-md-12"
          >
            <div
              v-if="allIcons.Phone != '' || allIcons.Phone != null"
              class="storelocater-col-md-2 stlc_padding_0px"
            >
              <img :alt="allIcons.PhoneAlt" :src="allIcons.Phone" class="stlc-store-list-icons" />
            </div>
            <p
              class="stlc_margin_left_right_5px storelocater-col-md-10 rfp-stlc-storelist-phonenumber stlc_padding_0px"
              :class="{
                'storelocater-col-md-12': allIcons.Phone === '' || allIcons.Phone === null,
              }"
            >
              <a
                class="rfp-stlc-storelist-phonenumber-txt"
                :data-googletag="item.Name"
                :href="'tel:' + item.PhoneNumber"
                @click="dataLayerTagging(callStoreTags, item.Name)"
              >
                {{ item.PhoneNumber }}
              </a>
            </p>
          </div>

          <div
            v-if="item.SocialNetworkLinks != null"
            class="stlc_padding_bottom_15px stlc__height_default storelocater-col-md-12"
          >
            <rfp-storelocator-social-links
              v-if="item.SocialNetworkLinks"
              :social-network-links="item.SocialNetworkLinks"
              :store-name="item.Name"
            >
            </rfp-storelocator-social-links>
          </div>

          <rfp-storelocator-store-attributes
            v-if="item.StoreAttributes"
            :store-attributes="item.StoreAttributes"
          >
          </rfp-storelocator-store-attributes>

          <div
            v-if="distanceEnable"
            class="stlc_padding_bottom_15px stlc__height_default storelocater-col-md-12"
          >
            <div
              v-if="allIcons.Distance != '' || allIcons.Distance != null"
              class="storelocater-col-md-2 stlc_padding_0px"
            >
              <img
                :alt="allIcons.DistanceAlt"
                :src="allIcons.Distance"
                class="stlc-store-list-icons"
              />
            </div>
            <div
              v-if="distanceEnable"
              class="storelocater-col-md-10 stlc_padding_0px"
              :class="{
                'storelocater-col-md-12': allIcons.Distance === '' || allIcons.Distance === null,
              }"
            >
              <div class="rfp-stlc-distance-type stlc_margin_left_right_5px">
                <span v-if="item.Distance != null">{{ item.Distance }}</span>
                <span v-if="distanceType != null">{{ distanceType }}</span>
              </div>
            </div>
          </div>

          <div
            v-if="!hideGetDirectionLink"
            class="stlc_padding_bottom_15px stlc__height_default storelocater-col-md-12"
          >
            <div
              v-if="allIcons.getDirections != '' || allIcons.getDirections != null"
              class="storelocater-col-md-2 stlc_padding_0px"
            >
              <img
                :alt="allIcons.getDirectionsAlt"
                :src="allIcons.getDirections"
                class="stlc-store-list-icons"
              />
            </div>
            <div
              class="storelocater-col-md-10 stlc_padding_0px"
              :class="{
                'storelocater-col-md-12':
                  allIcons.getDirections === '' || allIcons.getDirections === null,
              }"
            >
              <div
                v-if="item.Latitude || item.Longitude"
                role="link"
                tabindex="0"
                class="stlc_getdirection stlc_margin_left_right_5px"
                :data-googletag="item.Name"
                @click="getDirection(item)"
                @keydown.enter="getDirection(item)"
              >
                {{ getDirections }}
              </div>
              <div v-else class="stlc_margin_left_right_5px" :data-googletag="item.Name">
                {{ directionsNotFound }}
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="enableRtl && iriEnabled && !showMobileMedia"
          class="rfp-storelocator-index-design storelocater-col-md-1"
        >
          {{ item.Number }}
        </div>
        <div
          v-if="enableRtl && !iriEnabled && !showMobileMedia"
          class="rfp-storelocator-index-design storelocater-col-md-1"
        >
          {{ item.id }}
        </div>
      </li>
    </ul>
    <div>
      <rfp-stlc-pagination
        v-if="markerData.length > 0"
        v-bind="paginationConfig"
        @page-change="onPageChange"
      ></rfp-stlc-pagination>
    </div>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
import PromotionBannerEvent from '../promotion/promotion-banner-event';
import rfpStlcPagination from '../pagination/rfp-storelocator-pagination.vue';
import rfpStlcSocialLinks from '../social-links/rfp-storelocator-social-links.vue';
import rfpStlcStoreAttributes from '../store-attributes/rfp-storelocator-store-attributes.vue';
import { tryParseJson } from '../mixins/utils';
import { DisplayMode } from '../mixins/constants';

export default {
  name: 'rfp-storelocator-store-list',
  components: {
    'rfp-stlc-pagination': rfpStlcPagination,
    'rfp-storelocator-social-links': rfpStlcSocialLinks,
    'rfp-storelocator-store-attributes': rfpStlcStoreAttributes,
  },
  props: {
    btnPrev: {
      type: String,
      required: true,
    },
    btnNext: {
      type: String,
      required: true,
    },
    pagination: { type: String, required: true },
    paginationOf: { type: String, required: true },
    marker: {
      type: String,
      required: false,
      default: '',
    },
    storePaginationTagPrev: {
      type: Object,
      required: false,
      default: null,
    },
    storePaginationTagNext: {
      type: Object,
      required: false,
      default: null,
    },
    distanceEnable: {
      type: Boolean,
      required: false,
      default: false,
    },
    enableRtl: {
      type: Boolean,
      default: false,
    },
    getDirections: {
      type: String,
      required: false,
      default: '',
    },
    directionsNotFound: {
      type: String,
      required: false,
      default: '',
    },
    iriEnabled: {
      type: Boolean,
      required: false,
      default: true,
    },
    allIcons: {
      type: Object,
      required: true,
    },
    storesPerPage: {
      type: Number,
      required: true,
    },
    // TODO Global Tagging
    getDirectionTags: {
      type: String,
      required: false,
      default: '',
    },
    callStoreTags: {
      type: String,
      required: false,
      default: '',
    },
    bookStoreTags: {
      type: String,
      required: false,
      default: '',
    },
    hideGetDirectionLink: {
      type: Boolean,
      default: false,
    },
    displayMode: {
      type: String,
      required: false,
      default: DisplayMode.List,
      validator(value) {
        return Object.values(DisplayMode).includes(value);
      },
    },
    noStore: {
      type: String,
      required: true,
    },
    disableListItemNumbering: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      markerData: [],
      itemsPerPage: this.storesPerPage,
      activeStatus: 'none',
      paginationConfig: {
        prefixContent: this.pagination,
        middleContent: this.paginationOf,
        previousButtonText: this.btnPrev,
        nextButtonText: this.btnNext,
        currentPage: 0,
        lastPage: 0,
      },
      storeLists: {},
      distanceType: '',
      showMobileMedia: false,
      showListView: true,
      promotionEnabled: false,
    };
  },
  computed: {
    showItemNumber() {
      return !this.enableRtl && !this.showMobileMedia && !this.disableListItemNumbering;
    },
  },
  created() {
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    this._storeListMediaQuery = mediaQuery;
    this._storeListMediaQueryHandler = () => this.syncStoreListViewport();
    this.syncStoreListViewport();
    mediaQuery.addEventListener('change', this._storeListMediaQueryHandler);

    eventBus.on('pagination', ({ value, page }) => {
      this.markerData = value;
      this.activeStatus = 'block';
      this.storeLists[page] = this.markerData;
    });
    eventBus.on('pagination_new_count', () => {
      this.storeLists = {};
    });
    eventBus.on('salonList', () => {
      eventBus.emit('enableMap');
    });
    eventBus.on('salonListEmpty', () => {
      this.markerData = [];
      this.itemsPerPage = this.storesPerPage;
    });
    eventBus.on('rfp-distanceMatric', (value) => {
      this.distanceType = value;
    });
    eventBus.on('toggleStoreList', (value) => {
      this.showListView = !!value;
    });
    eventBus.on(PromotionBannerEvent.BannerEnabled, (val) => {
      this.promotionEnabled = val;
    });
    eventBus.on('pagination_record_count', (values) => {
      this.paginationConfig.currentPage = values.currentPage;
      this.paginationConfig.lastPage = values.lastPage;
    });
    eventBus.on('pagination_current_page', (currentPage) => {
      this.paginationConfig.currentPage = currentPage;
    });
  },
  beforeDestroy() {
    this._detachStoreListMediaQuery();
  },
  beforeUnmount() {
    this._detachStoreListMediaQuery();
  },
  methods: {
    _detachStoreListMediaQuery() {
      this._storeListMediaQuery?.removeEventListener('change', this._storeListMediaQueryHandler);
    },
    syncStoreListViewport() {
      this.showMobileMedia = this._storeListMediaQuery.matches;
      this.showListView = this.showMobileMedia ? this.displayMode !== DisplayMode.Map : true;
    },
    handleStoreClick(store) {
      eventBus.emit('focusOnStoreMarker', store);
    },
    onPageChange(page) {
      if (this.storeLists[page] === undefined) {
        eventBus.emit('get-store-list-from-pagination', page);
      } else {
        eventBus.emit('rfp-storelocator-enable-overlay');
        this.markerData = this.storeLists[page];
        eventBus.emit('update-google-map-center-place', {
          lat: this.markerData[0].Latitude,
          long: this.markerData[0].Longitude,
        });
        eventBus.emit('pagination_current_page', page);

        eventBus.emit('storeData', { value: this.markerData, page });
        eventBus.emit(PromotionBannerEvent.ListCollection, this.markerData);
        eventBus.emit('rfp-storelocator-disable-overlay');
      }
    },
    getWebsiteBaseData(urls) {
      return new URL(urls).origin;
    },
    getDirection(item) {
      this.dataLayerTagging(this.getDirectionTags, item.Name);
      window.open(`https://google.com/maps?q=${item.Latitude}, ${item.Longitude}`, '_blank');
    },
    dataLayerTagging(tags, storeName, socialNetwork, socialTarget) {
      if (!tags) return false;

      eventBus.emit('rfpTaggingPushToDatalayer', {
        tags: tryParseJson(tags),
        values: {
          storeName: storeName,
          socialNetwork: socialNetwork,
          socialTarget: socialTarget,
        },
      });
    },
  },
};
</script>
